export default __webpack_public_path__ + "static/shop-new-arrivals-d1130f04c9459151e7e5d476dbdd55eb.webp";